<template>
    <div class="numKeys base-button">
        <div>
            <slot name="numName"></slot>
        </div>
    </div>
</template>

<script>
export default { 
    name: 'NumKeys'

}
</script>

<style scoped>
    .numKeys{
        width: .666667rem;
        height: .666667rem;
        font-size: .46rem;
        border-radius: 50%;
        background: radial-gradient(#3f3e3f, #221f20 80%);
    }

    .numKeys:last-child{
        font-size: 0.33rem;
    }

    .numKeys::before{
        height: .16rem;
        top: .22rem;
    }

    .numKeys::after{
        height: .16rem;
        top: .22rem;
    }
</style>